import * as React from 'react';
import classNames from 'classnames';
import { TravelPolicyTabTypes } from '../../UserDetails/UserDetail';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const styles = require('./styles.pcss');

type Props = {
  text: { name: string; description: string };
  product: TravelPolicyTabTypes;
  flight?: any;
  hotel?: any;
  car?: any;
};

const TravelPolicyTableRows = (props: Props) => {
  const tableColumn = (row: any) => (
    <TableCell key={row.id} className={classNames(styles.tableCell)}>
      {row.name}
      {row.description && (
        <div className={styles.description}>{row.description}</div>
      )}
    </TableCell>
  );

  const renderTableCell = (row: any) => {
    return (
      <TableCell
        className={classNames(styles.tableCell, styles.tableCellStyle)}
      >
        {row}
      </TableCell>
    );
  };

  const renderArg = {
    [TravelPolicyTabTypes.flight]: props.flight,
    [TravelPolicyTabTypes.hotel]: props.hotel,
    [TravelPolicyTabTypes.car]: props.car,
  };

  return (
    <TableRow className={classNames(styles.tableRow)}>
      {tableColumn(props.text)}
      {renderTableCell(renderArg[props.product])}
    </TableRow>
  );
};
export default TravelPolicyTableRows;
